if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"_ciam_admin_ui_host","remotes":[{"alias":"@ciam-admin-ui/host","name":"_ciam_admin_ui_host","entry":"[@ciam-admin-ui/host]/bundle.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(197|219|85)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}